/**
 * Typed API client for the admin Edge Function.
 * All routes are platform.admin-gated on the server.
 */

import { adminAPIClient } from "./apiClients";
import type { AdminUser, CreateAdminUserParams } from "@shared/types/admin";
import type { AppRole } from "@shared/types/roles.ts";

export type { AdminUser, CreateAdminUserParams, AppRole };

export async function listAdminUsers(): Promise<AdminUser[]> {
  const { data } = await adminAPIClient.get<{ users: AdminUser[] }>("/users");
  return data.users;
}

export async function createAdminUser(params: CreateAdminUserParams): Promise<string> {
  const { data } = await adminAPIClient.post<{ id: string }>("/users", params);
  return data.id;
}

export async function updateUserRoles(userId: string, roles: AppRole[]): Promise<void> {
  await adminAPIClient.patch(`/users/${userId}/roles`, { roles });
}

export async function deactivateUser(userId: string): Promise<void> {
  await adminAPIClient.post(`/users/${userId}/deactivate`, {});
}

export async function reactivateUser(userId: string): Promise<void> {
  await adminAPIClient.post(`/users/${userId}/reactivate`, {});
}

export async function createExpertProfile(userId: string): Promise<void> {
  await adminAPIClient.post(`/users/${userId}/expert-profile`, {});
}

export async function updateExpertFields(userId: string, fields: string[]): Promise<void> {
  await adminAPIClient.put(`/users/${userId}/expert-fields`, { fields });
}

export async function sendPasswordReset(userId: string): Promise<void> {
  await adminAPIClient.post(`/users/${userId}/password-reset`, {});
}
